module.exports = __webpack_public_path__ + "static/media/find-challenge.7cdf2c9a.png";